import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridOptions, GridEmitter, UiGridComponent } from '@program-suite/ui-grid';
import { PolicyGridStore } from '@program-suite/data-common';
import { ButtonComponent } from '@program-suite/ui';
import { Sort } from '@angular/material/sort';
import { PolicyGridRowViewModel, PolicyGridOptions } from '@program-suite/data-common';
import { LookupStore } from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-policy-grid',
  imports: [CommonModule, UiGridComponent],
  templateUrl: './policy-grid.component.html',
  styleUrl: './policy-grid.component.scss',
})
export class PolicyGridComponent implements OnInit {
  policyGridStore = inject(PolicyGridStore);
  lookupStore = inject(LookupStore);
  authStore = inject(AuthStore);
  policyGridOptions = inject(PolicyGridOptions);
  defaultSortColumn: string = 'policyEffectiveDate';
  defaultSortDirection: string = 'DESCENDING';
  agencyId = signal<number | null | undefined>(this.authStore.user()?.agencyId ?? undefined);
  tenantId = signal<number | null | undefined>(null);
  gridOptions = signal<GridOptions>(
    this.authStore.isLossRunProcessor() ? this.policyGridOptions.LossRunProcessorOptions
    : this.authStore.isWholesale() ? this.policyGridOptions.WholesalerOptions
    : this.authStore.isAdmin() ? this.policyGridOptions.AdminOptions 
    :  this.policyGridOptions.OtherOptions
  );

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.agencyId()) {
      this.lookupStore.loadLookup('agents', this.agencyId() ?? 0);
    }
    if (this.authStore.isWholesale()) {
      this.lookupStore.loadLookup('agencies');
    }
    if (this.authStore.isAdmin()) {
      this.lookupStore.loadLookup('tenants');
    }
    this.lookupStore.loadLookup('submissionTypes');
    this.lookupStore.loadLookup('policyStatuses');
    this.lookupStore.loadLookup('programs');
  }

  fetchAll(rawParams?: any) {
    const { sortOrder, agencyId, tenantId } = rawParams;
    if (this.authStore.isAdmin()) {
      if (!tenantId) {
        this.lookupStore.clearLookup('agencies');
        this.tenantId.set(null);
      } else if (tenantId && this.tenantId() !== tenantId) {
        this.tenantId.set(tenantId);
        this.lookupStore.loadLookup('agencies', tenantId);
      }
    }
    if (this.authStore.isWholesale() || this.authStore.isAdmin()) {
      if (!agencyId) {
        this.lookupStore.clearLookup('agents');
        this.agencyId.set(null);
      } else if (agencyId && this.agencyId() !== agencyId) {
        this.agencyId.set(agencyId);
        this.lookupStore.loadLookup('agents', agencyId);
      }
    }
    const newSortOrder = this.sortField(sortOrder);
    const params = {
      ...rawParams,
        SortField: newSortOrder
          ? newSortOrder.active && newSortOrder.direction
            ? newSortOrder.active
            : this.defaultSortColumn
          : this.defaultSortColumn,
        SortDirection: newSortOrder ? newSortOrder.direction ?? this.defaultSortDirection : this.defaultSortDirection,
    }
    this.policyGridStore.setFilterValues(params);
  }

  sortField(sort: Sort) {
    let activeSort: string = this.defaultSortColumn;
    let direction: string | null = this.defaultSortDirection;
    if (sort !== null && sort !== undefined) {
      activeSort = sort.active;
      switch (true) {
        case sort.direction === 'desc':
          direction = 'DESCENDING';
          break;
        case sort.direction === 'asc':
          direction = 'ASCENDING';
          break;
        case sort.direction === '':
          direction = null;
          break;
      }
    }
    return { active: activeSort, direction: direction };
  }

  actionEvent(event: GridEmitter) {
    if (event.action === 'fetchAll') {
      this.fetchAll(event.data);
    } else if (event.action === 'formChanges') {
      this.fetchAll(event.data);
    } else if (event.action === 'clearFilters') {
      this.fetchAll(event.data);
    } else if (event.action === 'onDestroy') {
      // On destroy
    } else if (event.action === 'action') {
      const tab = this.authStore.isLossRunProcessor() ? 'lossruns' : 'summary';
      this.router.navigate(['policies', tab, (event.data as PolicyGridRowViewModel)?.id]);
    }
  }

  exportGrid() {
  }
}
